export default __webpack_public_path__ + "static/media/A9F6A50E-0BAD-4765-BB99-8ADC459F2641_1_105_c.aa30cde1.jpeg";